<template>
  <div>
    <article :class="isMobile ? 'isMobile' : ''">
      <div class="ribbon ribbon-top-right">
        <span>{{ribbon}}</span>
      </div>
      <slot />
      <!-- <div id="gitalk-container"></div> -->
      <vue-disqus
        :key="componentKey"
        class="disqus_wrapper"
        shortname="naenpiano"
        :identifier="$route.path"
        :url="'https://naenpiano.now.sh' + $route.path"
      ></vue-disqus>
    </article>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
// require('dotenv').config()

export default {
  name: "layout",
  props: {
    ribbon: {
      type: String,
      default: 'Web',
    }
  },
  components: {
  },
  data() {
    return {
      isMobile: isMobile,
      componentKey: 0
      // gitalk : new Gitalk({
      //   id: window.location.pathname,
      //   clientID: process.env.VUE_APP_CLIENT_ID,
      //   clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      //   repo: 'comments',
      //   owner: 'WeiChiaChang',
      //   admin: ['WeiChiaChang'],
      //   labels: ['WeiChiaChang'],
      //   perPage: 20,
      //   distractionFreeMode: false
      // })
    };
  },
  computed: {
    isDarkStatus () {
      return this.$store.state.app.darkTheme
    }
  },
  watch : {
    /* Reference:
    ** https://michaelnthiessen.com/force-re-render/
    ** 
        The correct way to force Vue to re-render a component
        The horrible way: reloading the entire page
        The terrible way: using the v-if hack
        The better way: using Vue's built-in forceUpdate method
        The best way: key-changing on your component
    **
    */ 
    isDarkStatus: function () {
      this.forceRerender()
    }
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    }
  },
  mounted () {
    // this.gitalk.render("gitalk-container")
  }
};
</script>

<style scoped lang="scss">
.isMobile {
  border: 0;
  margin-top: 0;
  overflow: hidden;
}
</style>